module.exports = __webpack_public_path__ + "img/202407_09.3148d4a0.jpg";